import { KoobMap, KoobMapClusterer } from '@koob/maps';
import { KoobCatalogMapLayout, KoobPagination } from '@koob/ui';
import Spinner from 'components/Spinner';
import { useApp } from 'hooks';
import ExperienceCard from './ExperienceCard';
import ExperienceMarker from './ExperienceMarker';

const ExperiencesMap = ({
  experiences,
  isLoading,
  isEmpty,
  emptyState,
  page,
  setPage,
  totalPages,
  totalCount,
  perPage,
  setPerPage,
}) => {
  const { currentOrganizationPosition } = useApp();

  return (
    <KoobCatalogMapLayout
      list={
        <>
          {experiences.map((experience) => (
            <ExperienceCard
              experience={experience}
              key={experience?.id}
              horizontal
            />
          ))}
          {isEmpty ? (
            !isLoading && emptyState
          ) : (
            <KoobPagination
              page={page}
              setPage={setPage}
              totalPages={totalPages}
              perPage={perPage}
              totalCount={totalCount}
              setPerPage={setPerPage}
              size="sm"
            />
          )}
        </>
      }
      map={
        <>
          {isLoading && <Spinner />}
          <KoobMap
            maxZoom={14}
            zoom={7}
            center={{
              lat: currentOrganizationPosition?.lat,
              lng: currentOrganizationPosition?.lon,
            }}
            fitMarkers
          >
            <KoobMapClusterer>
              {experiences?.map((experience) => (
                <ExperienceMarker
                  experience={experience}
                  key={experience?.id}
                />
              ))}
            </KoobMapClusterer>
          </KoobMap>
        </>
      }
    />
  );
};

export default ExperiencesMap;
